"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _modalSize = _interopRequireDefault(require("../constants/modalSize"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function getModalWidth(_ref) {
  var width = _ref.width,
      size = _ref.size,
      theme = _ref.theme;

  if (width) {
    return width;
  }

  return size === _modalSize["default"].BIG ? theme.widthLarge : theme.widthSmall;
}

function getModalHeight(_ref2) {
  var height = _ref2.height,
      theme = _ref2.theme;

  if (height) {
    return "height: ".concat(height, ";");
  }

  return "\n    min-height: ".concat(theme.minHeight, ";\n    max-height: ").concat(theme.maxHeight, ";\n  ");
}
/**
 * Return the button shadow based on props
 * @param {Object} props
 * @return {String}
 */


function getModalBoxShadow(_ref3) {
  var hasShadow = _ref3.hasShadow,
      theme = _ref3.theme;
  return "box-shadow: ".concat(hasShadow ? "".concat(theme.shadowSize, " ").concat(theme.shadowColor) : 'none');
}

var Container = _styledComponents["default"].div.attrs(function () {
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)('MODAL_CONTAINER'));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  position: fixed;\n  z-index: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex;
});

exports.Container = Container;

var Content = _styledComponents["default"].div.attrs(function (_ref5) {
  var testId = _ref5.testId;
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)(testId));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  ", ";\n  background: ", ";\n  ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  position: relative;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  ", ";\n  z-index: ", ";\n"])), getModalWidth, getModalHeight, function (_ref6) {
  var theme = _ref6.theme;
  return theme.backgroundColor;
}, function (props) {
  return getModalBoxShadow(props);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.animation;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.zIndex;
});

exports.Content = Content;